export { ReactComponent as Quiz } from './svgs/quiz.svg';
